const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "avatar",
  d: "M18.266,17.814a5.132,5.132,0,1,0-5.132-5.132A5.132,5.132,0,0,0,18.266,17.814Zm0-13.064a7.932,7.932,0,0,1,5.058,14.041,13.539,13.539,0,0,1,8.438,11.587A1.351,1.351,0,0,1,30.4,31.811,1.463,1.463,0,0,1,28.96,30.45a10.732,10.732,0,0,0-21.389,0,1.463,1.463,0,0,1-1.436,1.361A1.351,1.351,0,0,1,4.77,30.379a13.539,13.539,0,0,1,8.438-11.587A7.932,7.932,0,0,1,18.266,4.75Z",
  transform: "translate(-4.766 -4.75)",
  fill: "#eff4f8",
  fillRule: "evenodd"
});
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27.061,
    viewBox: "0 0 27 27.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.a0482c5281c102fe4d2c0ac1a5dd2ad7.svg";
export { ForwardRef as ReactComponent };